import React from "react";
import "./bill-list.less";
import {
  ListView,
  PullToRefresh,
  ActivityIndicator,
} from 'antd-mobile'
import ReactDOM from 'react-dom'
import { withRouter } from 'react-router'
import { billListApi } from "@/api/sany";
const APullToRefresh: any = PullToRefresh
const Footer = ({ isLoading, isHasMore, noHasMore }: any) => {
  if (!isHasMore) {
    return noHasMore || <div className="text-center">没有更多啦</div>
  }
  return (
    <div className="flex-lvc">
      {isLoading ? <ActivityIndicator text="加载中..." /> : ''}
    </div>
  )
}
@(withRouter as any)
export default class BillList extends React.Component<any, any> {
  lv: any
  dataBlobs: any = {}
  rowIDs: any = []
  isHasMore = false
  pageIndex = 1

  constructor(prop: any) {
    super(prop)
    this.rowIDs[0] = []
    const getSectionData = (dataBlob: any, sectionID: any) =>
      dataBlob[sectionID]
    const getRowData = (dataBlob: any, sectionID: any, rowID: any) =>
      dataBlob[rowID]

    const dataSource = new ListView.DataSource({
      getRowData,
      getSectionHeaderData: getSectionData,
      rowHasChanged: (row1: any, row2: any) => row1 !== row2,
      sectionHeaderHasChanged: (s1: any, s2: any) => s1 !== s2,
    })

    this.state = {
      dataSource,
      isLoading: true,
      height: (document.documentElement.clientHeight * 3) / 4,
    }

    //绑定this ios低版本不兼容箭头函数
    this.genData = this.genData.bind(this)
    this.onRefresh = this.onRefresh.bind(this)
    this.onEndReached = this.onEndReached.bind(this)
    this.cellClick = this.cellClick.bind(this)
  }

  componentDidMount() {
    const hei =
      document.documentElement.clientHeight -
      (ReactDOM.findDOMNode(this.lv) as any).getBoundingClientRect().top

    this.setState({
      height: hei,
    })
    this.genData()
  }

   //下拉刷新
   onRefresh() {
    if (this.state.isLoading) {
      return
    }
    this.pageIndex = 1
    this.rowIDs[0] = []
    this.dataBlobs['section0'] = 'section0'
    this.setState({ isRefreshing: true, isLoading: true })
    this.genData()
    this.setState({
      isRefreshing: false,
      isLoading: false,
    })
  }
  //上拉加载更多
  onEndReached(event: any) {
    // if (this.state.isLoading || !this.isHasMore) {
    //   return
    // }
    // this.pageIndex++
    // this.genData()
  }

  //分页请求
  async genData() {
    const type = this.props.type
    const checkinId = this.props.checkinId
    const customerId = this.props.customerId
    this.setState({
      isLoading: true
    })
    const {data} = await billListApi({type: type, checkinId: checkinId, customerId: customerId})
    this.setState({
      isLoading: false
    })
    // const res = JSON.parse(data)
    if (data.code === 'SUCCESS') {
      // this.isHasMore = !data.is_end
      data.data.forEach((item: any, index: number) => {
        const rowName = item.id
        this.dataBlobs[rowName] = item
        this.rowIDs[0].push(rowName)
      })

      const sectionIDs = [0]
      this.rowIDs = [...this.rowIDs]
      this.setState({
        dataSource: this.state.dataSource.cloneWithRowsAndSections(
          this.dataBlobs,
          sectionIDs,
          this.rowIDs,
        ),
      })
    }
  }

  //查看缴费详情
  cellClick(item: any) {
    // if (item.is_pay === '0') {
    //   this.props.history.push({
    //     pathname: '/sany/pay-bill',
    //     state: { ...item},
    //   })
    // }
  }

  render() {
    const { isRefreshing, isLoading } = this.state
    const { isHasMore } = this

    const header = (sectionData: any) => {
      return (
        <div className="section-header">
          {sectionData}
        </div>
      )
    }

    const row = (rowData: any, sectionID: any, rowID: any) => {
      let tagIcon = '/public/assets/img/bill_money.png'
      if (rowData.subject_name === '房费') {
        tagIcon = '/public/assets/img/bill_room.png'
      } else if (rowData.subject_name === '电费') {
        tagIcon = '/public/assets/img/bill_electric.png'
      } else if (rowData.subject_name === '冷水费') {
        tagIcon = '/public/assets/img/bill_cold_water.png'
      } else if (rowData.subject_name === '热水费') {
        tagIcon = '/public/assets/img/bill_cycle_water.png'
      } else if (rowData.subject_name === '中水费') {
        tagIcon = '/public/assets/img/bill_cycle_water.png'
      } else if (rowData.subject_name === '押金') {
        tagIcon = '/public/assets/img/bill_deposit.png'
      } else if (rowData.subject_name === '网络费') {
        tagIcon = '/public/assets/img/bill_network.png'
      } else if (rowData.subject_name === '有线电视费') {
        tagIcon = '/public/assets/img/bill_tv.png'
      } else {
        tagIcon = '/public/assets/img/bill_money.png'
      }
      return (
        <div className="bill-cell-bg" onClick={() => this.cellClick(rowData)}>
          <div className="bill-cell">
            <div className="between-row">
              <div className="img-row">
                <img src={tagIcon} alt="" style={{width: 24, height: 24}}/>
                <span style={{paddingLeft: '5px', fontSize: '14px'}}>{rowData.subject_name}</span>
              </div>
              <span style={{color: '#d5151f', fontSize: '18px'}}>￥{rowData.money}</span>
              </div>
            <div className="between-row">
              <span style={{color: '#949494', fontSize: '13px'}}>{rowData.start_day}~{rowData.end_day}</span>
              <span style={{color: '#949494', fontSize: '13px'}}>扣费方式：{rowData.bill_type_name}</span>
            </div>
            {rowData.remark ? <div style={{paddingBottom: '5px'}}>
              <span style={{color: '#949494', fontSize: '13px'}}>备注：{rowData.remark}</span>
            </div> : null}
            <div className="between-row" style={{borderTop: 'solid 1px #f2f2f2'}}>
              <span style={{color: '#949494', fontSize: '13px'}}>支付日期：{rowData.pay_at}</span>
              <span style={{color: rowData.is_pay ? '#ea6311': '#009bce', fontSize: '14px'}}>{rowData.is_pay_name}</span>
            </div>
          </div>
        </div>
      )
    }

    return (
      <ListView
        className="bill-list"
        ref={(el: any) => (this.lv = el)}
        dataSource={this.state.dataSource}
        renderFooter={() => (
          <Footer isLoading={isLoading} isHasMore={isHasMore} />
        )}
        renderSectionHeader={header}
        // renderSeparator={separator}
        renderRow={row}
        style={{
          height: this.state.height,
          overflow: 'auto',
        }}
        onEndReached={this.onEndReached}
        pullToRefresh={
          <APullToRefresh
            refreshing={isRefreshing}
            onRefresh={this.onRefresh}
          />
        }
      />
    )
  }
}